$(() => {
    handleSpainPricingLink();

    const params = new URLSearchParams(window.location.search);
    document.querySelector(`[data-toggle-target="${params.get('toggle')}"]`)?.click();
});

const handleSpainPricingLink = () => {
    if (Config.options.regionAndLanguage === 'es-es/' || Config.options.regionAndLanguage === 'es-en/') {
        const basePricingUrl = Config.options.rootUrl + Config.options.regionAndLanguage + 'pricing';
        $(".toggle-button").on("click", function() {
            $("#signup-button, #signup-button-mobile").attr("href", basePricingUrl + ($(this).data('toggle-target') === "canary" ? "?toggle=canary" : ""));
        });
    }
};
